import script from "./TgAppGateIn.vue?vue&type=script&setup=true&lang=js"
export * from "./TgAppGateIn.vue?vue&type=script&setup=true&lang=js"

import "./TgAppGateIn.vue?vue&type=style&index=0&id=37d5d494&scoped=true&lang=css"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37d5d494"]])

export default __exports__